<template>
  <div
    class="container mt-12 mt-sm-2"
    style="max-width: 800px"
  >
    <template v-if="step == 1">
      <div>
        <div class="d-flex flex-column">
          <v-autocomplete
            v-model="selectedClub"
            :loading="loading"
            :items="items"
            :search-input.sync="search"
            label="Club"
            item-text="local"
            item-value="id"
            return-object
            outlined
            hide-no-data
            :error-messages="selectedClubErrors"
            @blur="isSelectedClubDirty = true"
            :disabled="notFound"
          ></v-autocomplete>

          <v-checkbox
            v-model="notFound"
            label="My club is not on the list"
            class="ml-2"
            @change="onNotFoundChange"
          ></v-checkbox>

          <v-text-field
            v-if="notFound"
            v-model="clubName"
            label="Club Name"
            outlined
            @blur="isClubNameDirty = true"
            :error-messages="getErrors('clubName')"
          ></v-text-field>
        </div>

        <div class="d-flex flex-column flex-sm-row mb-4">
          <div class="col-12 col-sm-6 p-0 px-sm-4">
            <v-text-field
              v-model="name"
              label="Your Name"
              :error-messages="getErrors('guests.0.name')"
            ></v-text-field>
          </div>
          <div class="col-12 col-sm-6 p-0 px-sm-4">
            <v-text-field
              v-model="email"
              label="Your Email"
              :error-messages="getErrors('guests.0.email')"
            ></v-text-field>
          </div>
        </div>

        <div
          class="d-flex flex-column flex-sm-row mb-6"
          v-for="(guest, index) in guests"
        >
          <v-card class="w-100">
            <v-card-text>
              <div class="d-flex flex-column flex-sm-row">
                <div class="col-12 col-sm-6 p-0 px-sm-4">
                  <v-text-field
                    label="Colleague's Name"
                    v-model="guest.name"
                    :error-messages="getErrors(`guests.${index + 1}.name`)"
                  ></v-text-field>
                </div>
                <div class="col-12 col-sm-6 p-0 px-sm-4">
                  <v-text-field
                    label="Colleague's email"
                    v-model="guest.email"
                    :error-messages="getErrors(`guests.${index + 1}.email`)"
                  ></v-text-field>
                </div>
              </div>
              <v-btn
                dark
                color="red lighten-1"
                fab
                elevation="0"
                rounded
                small
                @click="removeGuest(index)"
                right
                bottom
                absolute
                background-color="white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-x"
                >
                  <line
                    x1="18"
                    y1="6"
                    x2="6"
                    y2="18"
                  ></line>
                  <line
                    x1="6"
                    y1="6"
                    x2="18"
                    y2="18"
                  ></line>
                </svg>
              </v-btn>
            </v-card-text>
          </v-card>
        </div>
        <div class="my-6 justify-center d-flex">
          <v-btn
            @click="add"
            outlined
          >
            Add Colleague
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
        </div>

        <v-checkbox
          class="tw-relative"
          v-model="tos"
        >
          <template #label>
            Ich akzeptiere die &nbsp;
            <a
              href="https://milchundbar.de/kontakt-impressum/"
              @click.stop
              target="_blank"
            >
              allgemeinen Geschäftsbedingungen
            </a>
          </template>
        </v-checkbox>
        <div
          v-if="tosError"
          class="tw-text-red-500 red--text"
        >
          {{ tosError }}
        </div>

        <v-btn
          color="primary"
          block
          @click="sendTickets"
        >
          Forward
          <v-icon small>mdi-forward</v-icon>
        </v-btn>
      </div>
    </template>
    <template v-if="step == 2">
      <p>Ihre Tickets wurden an die angegebenen E-Mail-Adressen gesendet.</p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Gastrosilvester',
  computed: {
    selectedClubErrors() {
      const errors = []
      if (!this.selectedClub && !this.notFound && this.isSelectedClubDirty) {
        errors.push(
          'Please select a club or check the box if your club is not on the list'
        )
      }
      return errors
    },
  },
  data() {
    return {
      step: 1,
      errors: [],
      name: '',
      email: '',
      guests: [],
      items: [],
      loading: false,
      selectedClub: null,
      search: null,
      notFound: false,
      isSelectedClubDirty: false,
      clubName: '',
      clubNameError: [],
      tos: false,
      tosError: '',
    }
  },
  watch: {
    search(val) {
      val && val !== this.selectedClub && this.querySelections(val)
    },
  },
  methods: {
    add() {
      this.guests.push({
        name: '',
        email: '',
      })
    },
    removeGuest(index) {
      this.guests.splice(index, 1)
    },
    querySelections(v) {
      this.loading = true
      axios.post('/gastrosilvester/search', { search: v }).then((res) => {
        this.items = res.data
        this.loading = false
      })
    },
    sendTickets() {
      if (!this.tos) {
        this.tosError =
          'Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen'
        return
      } else {
        this.tosError = ''
      }

      if (
        (!this.selectedClub && !this.notFound && !this.isSelectedClubDirty) ||
        (!this.selectedClub && !this.notFound)
      ) {
        this.isSelectedClubDirty = true
        return
      }
      if (this.notFound && !this.clubName) {
        this.errors = {
          clubName: ['Please enter a club name'],
        }
        return
      }

      const data = {
        guests: [
          {
            name: this.name,
            email: this.email,
          },
          ...this.guests,
        ],
        club: this.notFound
          ? { id: 0, local: this.clubName }
          : this.selectedClub,
        notFound: this.notFound,
      }
      axios
        .post('/gastrosilvester/send', data)
        .then((res) => {
          this.step = 2
        })
        .catch((err) => {
          this.errors = err.response.data.errors
        })
    },
    onNotFoundChange() {
      this.selectedClub = null
    },
    getErrors(field) {
      const errors = []
      if (this.errors[field]) {
        errors.push(this.errors[field][0])
      }
      return errors
    },
  },
}
</script>

<style scoped></style>
